module.exports = __webpack_public_path__ + "img/iPro_logo.99e460fc.png";